import http from './httpService';

export function getAllTypeGainLosses() {
  return http.get(`/type-gain-losses`);
}

export function createTypeGainLoss(payload) {
  return http.post(`/type-gain-losses`, payload);
}

export function updateTypeGainLoss(payload) {
  return http.put(`/type-gain-losses`, payload);
}

export function deleteTypeGainLoss(id) {
  return http.delete(`/type-gain-losses/${id}`);
}
